module.exports = __webpack_public_path__ + "img/zanwufajieqian.b5b2ba3e.png";